import React, { Component } from 'react';

import { Radio, Select, Input, Spin } from 'antd';

const TextArea = Input.TextArea;
const RadioGroup = Radio.Group;
const Option = Select.Option;


const APP_TABLE_INDEXES = {
    1: "一级指标",
    2: "二级指标",
    3: "三级指标",
    4: "四级指标",
    5: "五级指标",
    6: "六级指标",
    7: "七级指标",
    8: "八级指标",
    9: "九级指标",
};

class DataTable extends Component {
    constructor(props) {
        super(props);

        this.state = {
            data: [],
            scores: {},
            values: {},
            selects: {},
            columns: [],
            comment: '',
            loading: false,
            visible: false,
            readonly: props.keywords.readonly
        }

        this.dragData = {};
    }

    componentDidMount() {
        // this.querySearch({
        // "targetId": 327,
        // "bgTermId": 28,
        // "endTermId": 28,
        // "employeeId":8488,
        // "orgId":43
        // });
        this.props.api(this);
    }

    querySearch(params = {}) {
        this.setState({
            loading: true
        });

        return this.props.querySearch(params)
        .then(response => {
            this.setState({
                loading: false
            });
            
            this.setState(response);
            if(typeof this.props.setDomain === 'function') {
                this.props.setDomain(response.domain);
            }
        }).catch(error => {
            this.setState({
                loading: false
            });
        });
    }

    openModal() {
        this.props.onOpenModal();
    }

    getCoice(rowId, columnIndex) {
        return this.state.scores[rowId].choices[columnIndex];
    }

    getParents(id, parents, row) {
        if (parents.hasOwnProperty(id) === true) {
            return row.unshift(id), this.getParents(parents[id], parents, row);
        } else {
            return row.slice(1);
        }
    }

    onChange(columnIndex, rowIndex, rowId) {
        const choice = this.state.scores[rowId].choices[columnIndex];
        const data = this.range(+choice.valueLow, +choice.valueHigh);

        this.setState({
            selects: Object.assign({}, this.state.selects, {
                [rowId]: {
                    value: isNaN(+choice.valueNormal) ? 95 : +choice.valueNormal,
                    data,
                    index: columnIndex
                }
            })
        });
    }

    onSelect(value, rowId) {
        var select = Object.assign({}, this.state.selects[rowId], {
            value
        });

        this.setState({
            selects: Object.assign({}, this.state.selects, {
                [rowId]: select
            })
        });
    }

    onInput(value, rowId) {
        const choices = this.state.scores[rowId].choices;
        if (isNaN(+value) === false) {
            var data = this.queryChoiceRange(choices, +value);
            if (data.length) {
                const choice = data[0];
                var select = {
                    data: this.range(+choice.valueLow, +choice.valueHigh),
                    value: +value,
                    index: choice.index
                };

                this.setState({
                    selects: Object.assign({}, this.state.selects, {
                        [rowId]: select
                    })
                });
            }
        }
    }

    queryChoiceRange(choice, value) {
        return choice.map((d, i) => ({
            valueHigh: +d.valueHigh,
            valueNormal: +d.valueNormal,
            valueLow: +d.valueLow,
            label: d.label,
            index: i
        })).filter(d => {
            var min = +d.valueLow;
            var max = +d.valueHigh;
            return value <= max && value >= min;
        })
    }

    onEnter(index) {
        const table = this.refs.table;
        const inputs = table.querySelectorAll('input[type=text]');

        inputs[index + 1].select();
    }

    range(start, stop) {
        var result = [];
        for (stop; stop >= start; stop--) {
            result.push(stop);
        }

        return result;
    }

    componentWillReceiveProps(nextProps) {
        const v = nextProps.keywords.v;
        if(v !== this.props.keywords.v) {
            this.querySearch(nextProps.keywords);
        }

        this.setState({
            readonly: nextProps.keywords.readonly
        });

    }

    getEvalDataSource() {
        const {
            data,
            selects,
            scores,
            comment
        } = this.state;

        return {
            resultComment: comment,
            evalResult: data.map(d => {
                const id = d.id;
                const {
                    index,
                    value
                } = selects[id];

                const score = scores[id];
                const choice = score.choices[index];
                return {
                    questionId: score.id,
                    option: {
                        itemId: score.pid,
                        select: '',
                        selectScore: value,
                        selectLabel: choice.label
                    }
                }
            })
        };
    }

    setComment(comment) {

        this.setState({
            comment: comment + (this.state.comment ? (","+ this.state.comment) : "")
        });
        
    }

    render () {
        const state = this.state;

        return (
            <div className="root-main">
                <div className="data-table">
                    <div className="data-table-container">
                        <div className="data-table-header">
                            <table border="0" className="data-table-header">
                                <tr>
                                    {
                                        state.columns.map(column => (
                                            <th className="score-th" style={{width:120}}>{APP_TABLE_INDEXES[column]}</th>
                                        ))
                                    }
                                    <th>测评依据</th>
                                    <th style={{ width: 550 }}>存在问题</th>
                                    <th style={{ width: 100 }}>查看</th>
                                </tr>
                            </table>
                        </div>
                        <Spin  tip="数据加载中..." spinning={this.state.loading}>
                        <div className="data-table-body">
                            <div className="data-table-viewport">
                                <div className="data-table-content">
                                    <div className="data-table-main">
                                        <table border="0" ref="table">
                                            {
                                                state.data.map((row, rowIndex) => (
                                                    <tr>
                                                        {

                                                            row.columns.map(column => (
                                                                <td
                                                                    rowspan={column.rowspan}
                                                                    colspan={column.colspan}
                                                                    className="score-td"
                                                                    style={{width: 120}}
                                                                >
                                                                    {state.values[column.value]}
                                                                </td>
                                                            ))
                                                        }
                                                        
                                                        <td>{state.scores[row.id].label}</td>
                                                        <td style={{ width: 550 }}>
                                                            {
                                                                (state.scores[row.id].choices||[]).map((choice, i) => (
                                                                    <div>
                                                                    {choice}
                                                                    </div>
                                                                ))
                                                            }
                                                        </td>
                                                        <td style={{ width: 100 }}>
                                                            <a href="javascript:;" onClick={()=>{
                                                                this.props.onChartChange(state.scores[row.id].data);
                                                            }}>
                                                            数据展示
                                                            </a>
                                                        </td>
                                                    </tr>
                                                ))
                                            }
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                        </Spin>
                    
                    </div>
                </div>
            </div>
        );
    }
}

export default DataTable;